class PinchZoomGallery extends HTMLElement {
    constructor(){
        super();
        this.initialQueryLoaded = window.matchMedia("(max-width: 1024px)").matches;
        this.imgWrapper = this.querySelector(".product-medial-modal__img-wrapper");
        this.myElement = this.querySelector("img");
        this.pz = null;
        this.resizeHandler = this.resizeHandler.bind(this);
    }

    connectedCallback() {
        if (this.initialQueryLoaded) {
            this.initPinchZoom();
        }

        window.addEventListener('resize', this.resizeHandler);
    }

    /**
     * This function is called when the element is removed from the DOM. 
     * It removes the resize event listener and destroys the pinch zoom functionality.
     */
    disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);
        this.destroyPinchZoom();
    }

    /**
     * This method handles the logic when the window is resized. 
     * If the window width goes beyond the tablet width (1024px), it destroys the pinch zoom. 
     * If the window width is within the tablet range and the necessary elements are available and pinch zoom is not initialized, 
     * it initializes the pinch zoom.
     */
    resizeHandler() {
        const isTablet = window.matchMedia("(max-width: 1024px)").matches;
    
        if (!isTablet) {
            // Screen resized beyond tablet width, destroy PinchZoom
            this.destroyPinchZoom();
        } else if (isTablet && !this.pz && this.imgWrapper && this.myElement) {
            // Screen resized to tablet width and necessary elements are available, initialize PinchZoom
            this.initPinchZoom();
        }
    }
    
    initPinchZoom() {
        this.pz = new PinchZoom(this.myElement, {
            draggableUnzoomed: false,
            lockDragAxis: true,
            minZoom: 1,
            maxZoom: 3.5,
            use2d: true,
        });
    }

    destroyPinchZoom() {
        if (this.pz) {
            this.myElement.removeAttribute("style");
            this.imgWrapper.insertBefore(this.myElement, this.imgWrapper.firstChild);
            this.pz.destroy();
            this.pz = null;
        }
    }
}

customElements.define('pinch-zoom-gallery', PinchZoomGallery);
